import React from 'react';
import styles from './Content.module.scss';
import BlockContent from '../BlockContent';

const serializers = {
  types: {
    code: (props) => (
      <pre data-language={props.node.language}>
        <code>{props.node.code}</code>
      </pre>
    )
  }
};

const Content = ({ body, code, title }) => (
  <div className={styles['content']}>
    <h1 className={styles['content__title']}>{title}</h1>
    <div className={styles['content__body']}>
      {body && <BlockContent blocks={body} serializers={serializers}/>}
    </div>
  </div>
);

export default Content;
